<template>
  <v-menu
    v-model="calendarMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template #activator="{ on }">
      <div v-on="on">
        <v-text-field
          :disabled="disabled"
          :value="dateValue"
          :class="$vnode.data.staticClass"
          :label="label"
          :placeholder="placeholder"
          outlined
          dense
          :rules="rules"
          :required="required"
          append-icon="mdi-calendar"
          readonly="readonly"
          hide-details="auto"
          background-color="white"
          color="teal lighten-4"
        />
      </div>
    </template>
    <v-date-picker
      v-model="dateInPicker"
      :active-picker="activePicker"
      no-title
      :max="max"
      :min="min"
      :locale="language"
      :allowed-dates="allowedDates"
      @input="calendarMenu = false"
      @click:year="getDateTypes($event)"
      @click:month="getDateTypes($event)"
      @click:date="getDateTypes($event)"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  name: "CalendarInput",
  props: {
    date: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    max: { type: String, default: undefined },
    min: { type: String, default: undefined },
    initialPicker: { type: String, default: "YEAR" },
    rules: { type: Array, default: () => [] },
    allowedDates: {
      type: Function,
      default: () => () => true,
    },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["date"],
  data() {
    return {
      dateInPicker: "",
      calendarMenu: false,
      activePicker: null,
      language: undefined,
      calendarDate: "",
      dateHint: { d: "DD", m: "MM", y: "AAAA" },
      hintFormatted: undefined,
    };
  },
  computed: {
    dateValue() {
      let value = this.dateInPicker
        ? this.dateInPicker
        : this.date
        ? this.date
        : "";
      let text = value ? moment().format(value, "DD-MMM-YYYY") : "";
      if (this.isBefore(text)) text = "";
      return this.calendarMenu ? this.hintFormatted : text;
    },
  },
  watch: {
    calendarMenu(val) {
      this.setDefaultDate();
      val &&
        setTimeout(() => {
          this.activePicker = this.initialPicker;
        });
      //cuando se cierra el menú
      if (!this.calendarMenu) {
        //y hintFormatted ya no contiene letras
        if (
          /^[0-9/]*$/.test(this.dateHint.d + this.dateHint.m + this.dateHint.y)
        ) {
          // y hintFormatted no es igual a la fecha del padre
          if (this.hintFormatted != this.calendarDate) {
            //se emite la fecha del hintFormatted
            this.$emit("date", this.dateInPicker);
          }
        }
      }
    },
    min() {
      let value = this.dateInPicker
        ? this.dateInPicker
        : this.date
        ? this.date
        : "";
      if (this.isBefore(value)) {
        this.dateInPicker = "";
        this.hintFormatted = "DD/MM/AAAA";
        this.$emit("date", "");
      }
    },
  },
  created() {
    this.language = navigator.language || navigator.userLanguage;
    this.showDateHint();
  },
  methods: {
    showDateHint() {
      // this.hintFormatted = this.dateHint.m + '/' + this.dateHint.d + '/' + this.dateHint.y
      let mes =
        this.dateHint.m === "MM"
          ? "MM"
          : moment(this.dateHint.m, "MM")
              .locale("es-ES")
              .format("MMM")
              .slice(0, -1);
      this.hintFormatted = this.dateHint.d + "-" + mes + "-" + this.dateHint.y;
      return this.hintFormatted;
    },
    getDateTypes(date) {
      let dateParts = date.toString().split("-");
      if (dateParts.length > 0) this.dateHint["y"] = dateParts[0];
      if (dateParts.length > 1) this.dateHint["m"] = dateParts[1];
      if (dateParts.length > 2) this.dateHint["d"] = dateParts[2];
      this.showDateHint();
    },
    setDefaultDate() {
      let date = [null, undefined, ""].includes(this.date) ? "" : this.date;
      this.calendarDate = date;
      if (!this.dateInPicker.length && !this.calendarMenu)
        this.calendarDate = "";
    },
    isBefore(date) {
      if (this.min)
        if (date.length && this.min.length)
          return moment(date, "YYYY-MM-DD").isBefore(this.min);
      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
